module.exports = __webpack_public_path__ + "static/whiteroom_logo@2-e4235abf193de7b39257015519c04ace.png";